import { render, staticRenderFns } from "./Administration.vue?vue&type=template&id=918e2c5e&scoped=true"
import script from "./Administration.vue?vue&type=script&lang=js"
export * from "./Administration.vue?vue&type=script&lang=js"
import style0 from "./Administration.vue?vue&type=style&index=0&id=918e2c5e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918e2c5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3254644805/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('918e2c5e')) {
      api.createRecord('918e2c5e', component.options)
    } else {
      api.reload('918e2c5e', component.options)
    }
    module.hot.accept("./Administration.vue?vue&type=template&id=918e2c5e&scoped=true", function () {
      api.rerender('918e2c5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Containers/Administration.vue"
export default component.exports